import * as React from "react"
import { cn } from "../../lib/utils"

interface StatProps {
  label: React.ReactNode
  value: React.ReactNode
  icon?: React.ReactNode
  hint?: React.ReactNode
  className?: string
}

/** Compact metric tile: small label on top, large tabular figure below. */
function Stat({ label, value, icon, hint, className }: StatProps) {
  return (
    <div className={cn("rounded-xl border border-line bg-raised/60 p-3.5", className)}>
      <div className="flex items-center gap-1.5 text-xs font-medium text-fg-subtle [&_svg]:size-3.5">
        {icon}
        <span>{label}</span>
      </div>
      <div className="numeric mt-2 truncate text-xl font-medium text-fg">{value}</div>
      {hint && <div className="mt-0.5 truncate text-xs text-fg-subtle">{hint}</div>}
    </div>
  )
}

export { Stat }
